class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.scroller = '';
    this.scrollerIndex = 0;
    this.activeClass = 'active';
    this.messageClass = '.announcement-bar__message';
    this.announcements = this.querySelectorAll('.js-announcements');
    this.speedValue = this.dataset.speed || 5;
    this.scrollerSpeed = this.speedValue * 1000;
    this.barPadding = 6;

    this.init();
  }

  /*
   * Helper function to check if more than 1 announcement is set.
   */
  disableScrolling() {
    let disable = true;
    if (this.announcements.length > 1) {
      disable = false;
    }
    return disable;
  }

  /*
   * Helper function that removes active class on all announcement nodes.
   */
  clearActiveClass() {
    this.announcements.forEach((node) => {
      node.classList.remove(this.activeClass);
    });
  }

  /*
   * Helper function that removes active class on all announcement nodes.
   */
  setScrolling() {
    this.scroller = setInterval( () => {
      this.clearActiveClass();
      this.announcements[this.scrollerIndex].classList.add(this.activeClass);
      if (this.scrollerIndex + 1 >= this.announcements.length) {
        this.scrollerIndex = 0;
      } else {
        this.scrollerIndex++;
      }
    }, this.scrollerSpeed)
  }

  /*
   * Helper function that sets announcement bar height based on tallest message.
   */
  setHeight() {
    let barHeight = 0;
    this.announcements.forEach(announcement => {
      const message = announcement.querySelector(this.messageClass);
      if (message && barHeight < message.offsetHeight) {
        barHeight = message.offsetHeight;
      }
    });
    if ( barHeight > 0 ) {
      this.style.height = (barHeight + this.barPadding) + 'px';
    }
  }

  /*
   * Helper function to keep all event listeners in one spot.
   */
  setEvents() {
    window.addEventListener('resize', debounce(this.setHeight.bind(this), 250));
  }

  /*
   * Helper function that gets everything going once the constructor is instantiated.
   */
  init() {
    this.setEvents();
    this.setHeight();

    if (this.disableScrolling()) {
      return;
    }
    this.setScrolling();
  }
}

customElements.define('announcement-bar', AnnouncementBar);